import { gql } from '@apollo/client'

export const GET_MY_PIPELINE_CONFIG = gql`
  query GetMyPipelineConfig($pipeline: String!) {
    myPipelineConfig(pipeline: $pipeline) {
      pipeline
      config
      updatedAt
    }
  }
`

export const UPSERT_MY_PIPELINE_CONFIG = gql`
  mutation UpsertMyPipelineConfig($pipeline: String!, $config: JSON!) {
    upsertMyPipelineConfig(pipeline: $pipeline, config: $config) {
      pipeline
      config
      updatedAt
    }
  }
`

export const DELETE_MY_PIPELINE_CONFIG = gql`
  mutation DeleteMyPipelineConfig($pipeline: String!) {
    deleteMyPipelineConfig(pipeline: $pipeline)
  }
`
